export enum DataHooks {
  WeeklyTimetableLayout = 'weekly-timetable-layout',
  Timezone = 'timezone',
}
